/* eslint-disable quote-props */
import { loadAppointmentDetail } from "../calendar/actions";
import { ADMIN_ROLES } from "../auth";
import { ohCaseAppointmentRoute } from "../calendar/routes";

export const routes = {
    "/book-appointments": {
        title: "Book Appointments",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/clinic/:clinicId/appointment/:appointmentId": {
            title: "Appointment",
            resolve: [loadAppointmentDetail]
        },
        "/:bookTaskId/create-appointment": {
            title: "Book Appointment"
        },
        "/:bookTaskId/:clinicId/book-clinic-appointment": {
            title: "Book Appointment"
        },
        "/appointment/:appointmentId": {
            title: "Appointment",
            resolve: [loadAppointmentDetail]
        },
        "/:bookTaskId/:clinicId/open-clinic-appointments": {
            title: "Book Tasks",
            resolve: [loadAppointmentDetail]
        },
        ...ohCaseAppointmentRoute,
        "/create": {
            title: "Create Clinic"
        },
        "/create-mobile-clinic": {
            title: "Create Mobile Clinic"
        },
        "/create-time-note": {
            title: "Create Appointment"
        },
    }
};
